<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12 lg10 offset-lg1 xl6 offset-xl3>
        <h1 class="display-2 text-xs-center my-4">About Us</h1>
      </v-flex>
      <v-flex xs12 sm12 md12 lg10 offset-lg1 xl6 offset-xl3>
        <v-expansion-panel v-model="panel" popout expand>
          <v-expansion-panel-content>
            <v-layout slot="header" align-center row spacer>
              <v-flex xs4 sm2 mdl>
                <v-avatar slot="activator" size="36px">
                  <img
                    :src="require('../assets/PR_Logo-500w.png')"
                    alt="PR Properties Group"
                  />
                </v-avatar>
              </v-flex>
              <v-flex sm5 md3>
                <strong class="blue-grey--text text--darken-3">
                  PR Properties Group
                </strong>
              </v-flex>
              <v-flex hidden-xs-only>
                <strong class="blue-grey--text text--darken-3">
                  A Nevada Company
                </strong>
              </v-flex>
              <v-flex
                class="grey--text text--darken-2"
                ellipsis
                hidden-sm-and-down
              >
                &mdash; Las Vegas Real Estate Experts
              </v-flex>
            </v-layout>
            <v-card>
              <v-divider></v-divider>
              <div class="text-xs-center mt-4 mb-2">
                <img
                  :src="require('../assets/PR_Logo-500w.png')"
                  alt="PR Properties Group"
                  class="img--rounded"
                />
              </div>
              <v-card-text class="pa-4 body-1 blue-grey--text text--darken-3">
                <p>
                  PR Properties Group is a professional Real Estate company
                  serving the entire Las Vegas valley in both the Residential
                  and Commercial markets. In addition, PR Properties Group is
                  one of the First Paperless and Green Certified Real Estate
                  Brokerages in Nevada. We keep ourselves abreast of all
                  properties for sale or lease as well as compiling the most
                  current Demographics and Trends. This strategy allows PR
                  Properties Group to professionally service our clients in the
                  best manner possible – this is not a part time business for
                  us.
                </p>
                <p>
                  Furthermore, the PR Properties Group network of real estate
                  professionals has come together to form a synergistic group
                  that will assure you the very best local and national
                  marketing of your property. Whether you simply want to sell an
                  existing improved property, or would like to be involved in
                  the development and final build out of a parcel of land, PR
                  Properties Group can meet your needs.
                </p>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content>
            <v-layout slot="header" align-center row spacer>
              <v-flex xs4 sm2 mdl>
                <v-avatar slot="activator" size="36px">
                  <img
                    :src="
                      require('../assets/PR_Properties_Las_Vegas_Real_Estate_Phil_Roy_250w.jpg')
                    "
                    alt="Philip A Roy"
                  />
                </v-avatar>
              </v-flex>
              <v-flex sm5 md3>
                <strong class="blue-grey--text text--darken-3">
                  Philip A Roy
                </strong>
              </v-flex>
              <v-flex hidden-xs-only>
                <strong class="blue-grey--text text--darken-3">
                  Real Estate Broker
                </strong>
              </v-flex>
              <v-flex
                class="grey--text text--darken-2"
                ellipsis
                hidden-sm-and-down
              >
                &mdash; Professional Real Estate Broker
              </v-flex>
            </v-layout>
            <v-card>
              <v-divider></v-divider>
              <div class="text-xs-center mt-4 mb-2">
                <img
                  :src="
                    require('../assets/PR_Properties_Las_Vegas_Real_Estate_Phil_Roy_250w.jpg')
                  "
                  alt="Philip A Roy"
                  class="img--rounded"
                />
              </div>
              <v-card-text class="pa-4 body-1 blue-grey--text text--darken-3">
                <p>
                  Philip Roy began his real estate career in Scottsdale, Arizona
                  in 1988 after finishing college at Arizona State University.
                  Phil worked in both residential and commercial real estate
                  until the local real estate market overbuilt itself in mid
                  1990. The greater Phoenix area became so overbuilt that the
                  demand for real property totally ceased and therefore Phil was
                  forced to make a career change. Phil owned an aircraft at the
                  time the real estate market collapsed and decided that he
                  would like to fly professionally. In July of 1990 Phil moved
                  to Las Vegas and became a professional pilot.
                </p>
                <p>
                  After more than a decade of being a professional pilot, Phil
                  decided that he wanted to get back into real estate. Phil
                  obtained his Nevada real estate Broker's license and formed PR
                  Properties Group. Phil was so busy that he decided to take a
                  leave of absence from his airline job so he could practice
                  real estate full time. Phil has amassed over One Hundred Sixty
                  Million Dollars in Closed Commercial and Residential Real
                  Estate Transactions in the last few years.
                </p>
                <p>
                  Phil concentrates on Residential Acquisition and Disposition
                  but also does Commercial Retail Sales and Leasing and large
                  Multi-family. Phil has been so successful and enjoyed real
                  estate so much that he has not gone back to flying. Phil has
                  been awarded the National Association of Realtor’s most
                  prestigious Residential Realtor Designation the Certified
                  Residential Specialist CRS® Designation along with the
                  Accredited Buyer Representative ABR® Designation, NAR's GREEN®
                  Designation, the Short Sale and Foreclosure Resource SFR
                  Certification, and the Military Relocation Professional MRP
                  Certification.
                </p>
                <h4>BUYING A HOME:</h4>
                <p>
                  As Your Agent, I Will Assure that you see all the properties
                  in the area that meet your criteria. Guide you through the
                  entire home buying process, from finding homes to look at, to
                  assisting in getting the best financing. Make sure you don't
                  pay too much for your new home and help you avoid costly
                  mistakes. I will Answer all of your questions about the local
                  market area, including schools, neighborhoods, the local
                  economy, and more.
                </p>
                <h4>SELLING YOUR HOME:</h4>
                <p>
                  As Your Agent, I Will Complete a Qualified Home Assessment
                  that will compare your home's market position requirement to
                  that of your neighbors. Compile a comprehensive plan detailing
                  all the efforts I will employ to sell your home, including the
                  Internet and social media. Present your home to as many
                  qualified buyers as possible getting your home maximum
                  exposure. Help you stage your home and generate curb appeal to
                  ensure you get the highest price. Assist with obtaining offers
                  and help you in negotiating the best deal as smoothly as
                  possible. Help you find your next home and answer all of your
                  questions about the local market area, including schools,
                  neighborhoods, the local economy, and more.
                </p>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
      <v-flex text-xs-center mt-4 xs12 sm12 md12 lg10 offset-lg1 xl6 offset-xl3>
        <img :src="logo" alt="PR Properties Group Logo" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'About',
  data() {
    return {
      panel: [true, true],
      logo: require('../assets/PR_Logo.svg'),
    };
  },
  metaInfo: {
    title: 'About Us',
  },
};
</script>

<style scoped>
img {
  max-width: 250px;
}

.img--rounded {
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  padding: 4px;
}
</style>
